import styled from "styled-components";
import Breakpoints from "../config/Breakpoints";

const LuckyNumberPromoList = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;

    .warningBlock {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        width: 100%;
        height: auto;
        border-radius: .5rem;
        background: var(--color-xLightGray);
        color: var(--color-gray);
        justify-content: center;
        align-items: center;
        aspect-ratio: 100/35;
    }

    .skeleton {
        aspect-ratio: 100/70;
        border-radius: .5rem;
        width: 100%;
        height: auto;
    }

    @media ${Breakpoints.md} {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 1.5rem;

         .twoColumn {
            grid-column-start: 1;
            grid-column-end: 3;
        }
    }
`;

export default LuckyNumberPromoList;